import React from 'react';

// Deterministic warm-medical palette — every resident always renders in the
// same colour, derived from their name, so the UI is stable across reloads.
const PALETTE = [
  { bg: '#dfe7d6', fg: '#3f5b3a' }, // sage
  { bg: '#f0d9c8', fg: '#8a4a2a' }, // terracotta
  { bg: '#ece1cf', fg: '#7a5a2a' }, // sand
  { bg: '#d8e3e0', fg: '#2f5854' }, // teal
  { bg: '#e6dfe8', fg: '#5a3f6b' }, // mauve
  { bg: '#e9dcd2', fg: '#6b4a2f' }, // clay
];

const hashName = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0;
  }
  return h;
};

const initials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export default function ResidentAvatar({ name, src, size = 56, rounded = 'full', className = '', testid }) {
  const [errored, setErrored] = React.useState(false);
  const showImage = src && !errored;
  const colour = PALETTE[hashName(name) % PALETTE.length];
  const radius = rounded === 'full' ? '9999px' : rounded === '2xl' ? '1rem' : '0.75rem';
  const fontSize = Math.round(size * 0.38);

  if (showImage) {
    return (
      <img
        src={src}
        alt={name || ''}
        onError={() => setErrored(true)}
        data-testid={testid}
        className={`object-cover border border-stone_line ${className}`}
        style={{ width: size, height: size, borderRadius: radius }}
      />
    );
  }

  return (
    <div
      data-testid={testid}
      aria-label={name}
      className={`grid place-items-center font-heading select-none border border-stone_line ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: colour.bg,
        color: colour.fg,
        fontSize,
        letterSpacing: '0.02em',
      }}
    >
      {initials(name)}
    </div>
  );
}
